module.exports = __webpack_public_path__ + "static/media/wood.80fb52e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/wood.jpg
// module id = 180
// module chunks = 0